import { get } from 'lodash';
import {
	GO_TO_PAYMENTS_PAGE,
	GO_TO_DEBIT_PAYMENTS_PAGE,
	GO_TO_DEBIT_LANDING_PAGE,
	GO_TO_CREDIT_LANDING_PAGE,
	GO_BACK_PAGE,
	GO_TO_REVIEW,
	GO_TO_PAYMENTS,
	GO_TO_PAYMENTS_LANDING_PAGE,
	GO_TO_ADD_PAYEE_LANDING_PAGE,
	SET_BACK_PAGE,
	GO_TO_PAGE,
	GO_TO_PREVIOUS_PAGE,
	GO_TO_IMPORT_PAYEES_PAGE,
	SET_SHARED_DATA,
	pages,
	CREATE_NEW_BACS_TEMPLATE,
	RESET_APP,
} from './actions';
import {
	SUBMIT_CALENDAR_FAILURE,
	SUBMIT_CALENDAR_REQUEST,
	SUBMIT_CALENDAR_CUTOFF_REQUEST,
	SUBMIT_CALENDAR_CUTOFF_FAILURE,
} from '../calendar/actions';
import { TYPE_BACS_CREDIT } from '../../config';
import { INIT_PAYMENTS } from '../payments/actions';
import {
	SUBMIT_CREATE_TEMPLATE_FAILURE,
	GO_TO_BACS_TEMPLATE,
	GO_TO_EDIT_FASTERPAYMENT_TEMPLATE,
	INIT_PAYMENTS_FOR_TEMPLATE,
} from '../templates/actions';
import {
	BENEFICIARY_CREATE_REQUEST,
	BENEFICIARY_CREATE_FAILURE,
	GET_ALL_BENEFICIARIES_FAILURE,
	BENEFICIARY_CREATE_SUCCESS,
	GET_BENEFICIARY_DETAILS_BY_ID_FAILURE,
} from '../payees/actions';

import {
	GET_ALL_MANDATES_REQUEST,
	GET_ALL_MANDATES_FAILURE,
	RESET_MANDATE_LIST,
	GET_MANDATES_MULTIPART_SUCCESS,
	VIEW_MANDATE,
	VIEW_MANDATE_BACK,
	EDIT_MANDATE,
} from '../managePayments/actions';
import {
	SUBMIT_BACS_PAYMENT_REVIEW_SUCCESS,
	SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_SUCCESS,
	SUBMIT_CONFIRMED_BACS_PAYMENTS_SUCCESS,
	SUBMIT_BACS_PAYMENT_REVIEW_REQUEST,
	SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST,
	SUBMIT_BACS_PAYMENT_REVIEW_FAILURE,
	SUBMIT_CONFIRMED_BACS_PAYMENTS_FAILURE,
	SUBMIT_BACSDEBIT_PAYMENT_REVIEW_SUCCESS,
	SUBMIT_BACSDEBIT_PAYMENT_REVIEW_FAILURE,
	SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_FAILURE,
	SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST,
	SUBMIT_BACSDEBIT_PAYMENT_REVIEW_REQUEST,
} from '../api/bacsActions';

import {
	SUBMIT_PAYMENT_REVIEW_SUCCESS,
	SUBMIT_PAYMENT_REVIEW_FAILURE,
	SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS,
	SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE,
	SUBMIT_CONFIRMED_PAYMENT_SUCCESS,
	SUBMIT_CONFIRMED_PAYMENT_FAILURE,
	SUBMIT_BATCH_REVIEW_SUCCESS,
	SUBMIT_BATCH_REVIEW_FAILURE,
	SUBMIT_BATCH_SUCCESS,
	SUBMIT_BATCH_FAILURE,
	SUBMIT_REPEATING_PAYMENT_REVIEW_SUCCESS,
	SUBMIT_REPEATING_PAYMENT_REVIEW_FAILURE,
	SUBMIT_CONFIRMED_REPEATING_PAYMENT_SUCCESS,
	SUBMIT_CONFIRMED_REPEATING_PAYMENT_FAILURE,
	CANCEL_BATCH_APPROVAL_FAILURE,
	SUBMIT_PAYMENT_REVIEW_REQUEST,
	SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST,
	SUBMIT_CONFIRMED_PAYMENT_REQUEST,
	SUBMIT_BATCH_REVIEW_REQUEST,
	SUBMIT_CONFIRMED_BATCH_PAYMENTS_REQUEST,
	SUBMIT_BATCH_REQUEST,
	SUBMIT_REPEATING_PAYMENT_REVIEW_REQUEST,
	SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST,
	CANCEL_BATCH_APPROVAL_REQUEST,
	CANCEL_PAYMENT_APPROVAL_REQUEST,
	CANCEL_PAYMENT_APPROVAL_FAILURE,
	STORE_BATCH_BUSINESS_ERROR,
	GO_TO_VIEW_PAYEE_PAGE,
	GO_TO_EDIT_PAYEE_PAGE,
	GO_TO_EDIT_CHAPS_PAGE,
	API_ERROR,
	SUBMIT_CONFIRMED_BATCH_PAYMENTS_FAILURE,
} from '../api/fasterPaymentActions';
import { GO_TO_MANAGE_PAYEE_PAGE } from '../api/goToManagePayeePage';
import {
	SUBMIT_CHAPS_BATCH_SUCCESS,
	SUBMIT_CHAPS_BATCH_FAILURE,
	SUBMIT_CHAPS_BATCH_REQUEST,
	SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST,
	SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS,
	SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE,
	SUBMIT_CHAPS_PAYMENT_REVIEW_REQUEST,
	SUBMIT_CHAPS_PAYMENT_REVIEW_SUCCESS,
	SUBMIT_CHAPS_PAYMENT_REVIEW_FAILURE,
	SUBMIT_CHAPS_CONFIRMED_PAYMENT_SUCCESS,
	SUBMIT_CHAPS_CONFIRMED_PAYMENT_FAILURE,
	SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST,
	SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_REQUEST,
	SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_FAILURE,
	SUBMIT_CHAPS_EDIT_PAYMENT_REQUEST,
	SUBMIT_CHAPS_EDIT_PAYMENT_FAILURE,
	SUBMIT_BATCH_CHAPS_REVIEW_REQUEST,
	SUBMIT_BATCH_CHAPS_REVIEW_SUCCESS,
	SUBMIT_BATCH_CHAPS_REVIEW_FAILURE,
	SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_REQUEST,
} from '../api/chapsActions';
import {
	SUBMIT_GET_EXCHANGE_RATES_REQUEST,
	SUBMIT_GET_CHAPS_RATES_SUCCESS,
	SUBMIT_GET_CHAPS_RATES_FAILURE,
} from '../rates/actions';
import {
	SUBMIT_ADD_PAYEE_REQUEST,
	SUBMIT_ADD_PAYEE_SUCCESS,
	SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS,
	SUBMIT_ADD_PAYEE_FAILURE,
	SUBMIT_ADD_INTERNATIONAL_PAYEE_REQUEST,
	SUBMIT_ADD_INTERNATIONAL_PAYEE_FAILURE,
} from '../../payees/states/addPayee/actions';
import {
	SUBMIT_IFT_EDIT_PAYMENT_REQUEST,
	SUBMIT_GET_IFT_PAYMENT_TO_EDIT_REQUEST,
	SUBMIT_IFT_PAYMENT_REVIEW_REQUEST,
	SUBMIT_IFT_PAYMENT_CONFIRMED_REQUEST,
	SUBMIT_IFT_PAYMENT_REVIEW_FAILURE,
	SUBMIT_IFT_PAYMENT_CONFIRMED_FAILURE,
	SUBMIT_IFT_EDIT_PAYMENT_FAILURE,
	SUBMIT_IFT_PAYMENT_REVIEW_SUCCESS,
	SUBMIT_IFT_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST,
	SUBMIT_IFT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS,
	SUBMIT_IFT_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE,
} from '../ift/actions';
import { SUBMIT_DELETE_PAYEE_FAILURE, SUBMIT_DELETE_PAYEE_REQUEST } from '../../managePayee/states/action';
import { GET_CUSTOMER_CAPABILITIES_FAILURE } from '../limits/actions';

import {
	getApiResponses,
	hasConflictError,
	hasMissedDeadlineError,
	isConflictStatus,
	isUnauthorisedStatus,
	isCustomerDeviceErrorResponse,
	isMultiPartFailure,
	isBadRequestStatus,
	isDailyLimitOrCustomerDeviceError,
	hasBeneficiaryFailed,
	isDailyLimitErrorResponse,
	isMaxTransactionLimitErrorResponse,
	isReadTimeOutStatus,
	isForbidden,
	isRepeatingPaymentLimitErrorResponse,
} from '../../helpers/apiResponse';
import {
	GET_ACCOUNT_DETAILS_BY_ID_FAILURE,
	GET_ACCOUNTS_BY_CAPABILITY_FAILURE,
	GET_ACCOUNTS_PAGE_FAILURE,
	GET_PAYEES_PAGE_FAILURE,
} from '../accountPaging/constants';
import { GET_ALL_MISSING_DETAILS_FAILURE } from '../../utils/LCVMissingDetailsUtils';
import { CANCEL_PAYMENT_FAILURE } from '../../effectiveWarning/state/actions';

const requestActions = [
	SUBMIT_BACS_PAYMENT_REVIEW_REQUEST,
	SUBMIT_CONFIRMED_BACS_PAYMENTS_REQUEST,
	SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_REQUEST,
	SUBMIT_BACSDEBIT_PAYMENT_REVIEW_REQUEST,
	CANCEL_PAYMENT_APPROVAL_REQUEST,
	SUBMIT_CALENDAR_REQUEST,
	GET_ALL_MANDATES_REQUEST,
	SUBMIT_PAYMENT_REVIEW_REQUEST,
	SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST,
	SUBMIT_CONFIRMED_PAYMENT_REQUEST,
	SUBMIT_BATCH_REVIEW_REQUEST,
	SUBMIT_BATCH_CHAPS_REVIEW_REQUEST,
	SUBMIT_CONFIRMED_BATCH_PAYMENTS_REQUEST,
	SUBMIT_BATCH_REQUEST,
	SUBMIT_REPEATING_PAYMENT_REVIEW_REQUEST,
	SUBMIT_CONFIRMED_REPEATING_PAYMENT_REQUEST,
	CANCEL_BATCH_APPROVAL_REQUEST,
	BENEFICIARY_CREATE_REQUEST,
	SUBMIT_CALENDAR_CUTOFF_REQUEST,
	SUBMIT_ADD_PAYEE_REQUEST,
	SUBMIT_GET_EXCHANGE_RATES_REQUEST,
	SUBMIT_IFT_EDIT_PAYMENT_REQUEST,
	SUBMIT_GET_IFT_PAYMENT_TO_EDIT_REQUEST,
	SUBMIT_IFT_PAYMENT_REVIEW_REQUEST,
	SUBMIT_IFT_PAYMENT_CONFIRMED_REQUEST,
	SUBMIT_DELETE_PAYEE_REQUEST,
	SUBMIT_ADD_INTERNATIONAL_PAYEE_REQUEST,
	SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST,
	SUBMIT_CHAPS_PAYMENT_REVIEW_REQUEST,
	SUBMIT_CHAPS_CONFIRMED_PAYMENT_REQUEST,
	SUBMIT_CHAPS_BATCH_REQUEST,
	SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_REQUEST,
	SUBMIT_CHAPS_EDIT_PAYMENT_REQUEST,
	SUBMIT_GET_CHAPS_PAYMENT_TO_EDIT_REQUEST,
	SUBMIT_IFT_PAYMENT_DAILY_LIMIT_REVIEW_REQUEST,
];

const failureActions = [
	SUBMIT_CALENDAR_FAILURE,
	CANCEL_PAYMENT_APPROVAL_FAILURE,
	GET_ALL_MANDATES_FAILURE,
	SUBMIT_DELETE_PAYEE_FAILURE,
	SUBMIT_CHAPS_PAYMENT_REVIEW_FAILURE,
	SUBMIT_GET_CHAPS_RATES_FAILURE,
	SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE,
	SUBMIT_PAYMENT_REVIEW_FAILURE,
	SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE,
	SUBMIT_BATCH_REVIEW_FAILURE,
	BENEFICIARY_CREATE_FAILURE,
	SUBMIT_BATCH_CHAPS_REVIEW_FAILURE,
	SUBMIT_CHAPS_CONFIRMED_BATCH_PAYMENTS_FAILURE,
	SUBMIT_CONFIRMED_BATCH_PAYMENTS_FAILURE,
	GET_CUSTOMER_CAPABILITIES_FAILURE,
	GET_ALL_BENEFICIARIES_FAILURE,
	API_ERROR,
	SUBMIT_IFT_PAYMENT_REVIEW_FAILURE,
	SUBMIT_CALENDAR_CUTOFF_FAILURE,
	CANCEL_PAYMENT_APPROVAL_FAILURE,
	CANCEL_BATCH_APPROVAL_FAILURE,
	SUBMIT_IFT_PAYMENT_DAILY_LIMIT_REVIEW_FAILURE,
	GET_BENEFICIARY_DETAILS_BY_ID_FAILURE,
	GET_ACCOUNTS_BY_CAPABILITY_FAILURE,
	GET_ACCOUNTS_PAGE_FAILURE,
	GET_PAYEES_PAGE_FAILURE,
	GET_ALL_MISSING_DETAILS_FAILURE,
	CANCEL_PAYMENT_FAILURE,
];

const pagename = 'BacsCreditLanding';
const initialPage = {
	name: pagename,
	backPage: [],
};

const goBackTransitions = {
	PaymentsLandingPage: '',
	Payments: '',
	Review: 'Payments',
	Confirmed: 'Review',
	PaymentsEditTemplate: 'PaymentsLandingPage',
	PaymentsCreateNewTemplate: 'PaymentsLandingPage',
	BacsCreditLanding: '',
	BacsCreditPayments: '',
	BacsCreditReview: 'BacsCreditPayments',
	BacsDebitReview: 'BacsDebitPayments',
	BacsCreditPaymentsTemplate: 'BacsCreditLanding',
	BacsDebitPaymentsTemplate: 'BacsDebitLanding',
	ChapsReview: pages.ChapsPayments,
	ChapsPayments: pages.ChapsLandingPage,
	BacsImportedCreditPayments: pages.BacsCreditLanding,
	BacsImportedDebitPayments: pages.BacsDebitLanding,
	ImportedFasterPayments: pages.FasterPaymentsLandingPage,
	ImportedChapsPayments: pages.ChapsLandingPage,
	EwPaymentReason: 'Review',
};

const isSingleChapsPayment = (responses) => !(responses.length > 1);

const page = (state = initialPage, action) => {
	// TODO: refactor to look for _REQUEST in action type and have an 'exclusion' list of actions to ignore
	if (requestActions.includes(action.type) && get(action, 'error', false)) {
		return {
			...state,
			hasError: true,
		};
	}
	if (failureActions.includes(action.type)) {
		return {
			...state,
			hasError: true,
		};
	}

	switch (action.type) {
		case GO_BACK_PAGE: {
			if (state.backPage && state.backPage.length) {
				const newBackPageArray = state.backPage;
				const backPage = newBackPageArray.pop();
				return { ...state, name: backPage, backPage: newBackPageArray };
			}
			const currentPage = get(state, 'name', '');
			const name = goBackTransitions[currentPage];
			if (!name) return state;
			return { ...state, name };
		}
		case SET_BACK_PAGE: {
			const { backPage = [] } = state;
			return {
				...state,
				backPage: [...backPage, action.backPage],
			};
		}
		case GO_TO_PAGE: {
			return { ...state, name: action.name, previousPage: state.name };
		}
		case GO_TO_PREVIOUS_PAGE: {
			if (state.previousPage) return { ...state, name: state.previousPage, previousPage: '' };
			return state;
		}
		case GO_TO_REVIEW: {
			return {
				...state,
				name: 'Review',
			};
		}
		case GO_TO_PAYMENTS:
		case INIT_PAYMENTS: {
			return {
				...state,
				name: 'Payments',
			};
		}
		case GO_TO_ADD_PAYEE_LANDING_PAGE: {
			return {
				...state,
				name: 'Payee/Add',
			};
		}
		case GO_TO_EDIT_PAYEE_PAGE: {
			return {
				...state,
				name: 'Payee/Edit',
			};
		}
		case GO_TO_EDIT_CHAPS_PAGE: {
			return {
				...state,
				name: 'Payee/Chaps',
			};
		}
		case SUBMIT_ADD_INTERNATIONAL_PAYEE_SUCCESS:
		case SUBMIT_ADD_PAYEE_SUCCESS: {
			const {
				meta: { isPaymentFlow },
			} = action;
			if (isPaymentFlow || get(action, 'payload.code') === 409) {
				return state;
			}
			return {
				...state,
				name: 'Payee/Success',
			};
		}
		case GO_TO_PAYMENTS_LANDING_PAGE: {
			return {
				...state,
				...action.page,
			};
		}
		case SUBMIT_IFT_PAYMENT_REVIEW_SUCCESS: {
			const { hasFailure } = isMultiPartFailure(action);
			if (hasFailure) return { ...state, hasError: true };
			return state;
		}
		case SUBMIT_CHAPS_PAYMENT_REVIEW_SUCCESS:
		case SUBMIT_PAYMENT_REVIEW_SUCCESS: {
			const { hasFailure, responses } = isMultiPartFailure(action);
			if (hasFailure) return { ...state, hasError: true };

			const maxLimitExceeded = hasConflictError(responses);
			if (maxLimitExceeded) return state;
			const page = action.type === SUBMIT_CHAPS_PAYMENT_REVIEW_SUCCESS ? pages.ChapsReview : 'Review';
			const previousPage = action.type === SUBMIT_CHAPS_PAYMENT_REVIEW_SUCCESS && pages.ChapsLandingPage;

			return { ...state, name: page, ...(previousPage && { previousPage }) };
		}
		case SUBMIT_GET_CHAPS_RATES_SUCCESS:
		case SUBMIT_CHAPS_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS:
		case SUBMIT_IFT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS:
		case SUBMIT_PAYMENT_DAILY_LIMIT_REVIEW_SUCCESS: {
			const { hasFailure } = isMultiPartFailure(action);
			if (hasFailure) return { ...state, hasError: true };
			return state;
		}
		case SUBMIT_CONFIRMED_PAYMENT_SUCCESS:
			return { ...state, name: 'Confirmed' };
		case SUBMIT_CHAPS_CONFIRMED_PAYMENT_SUCCESS: {
			const responses = getApiResponses(action);
			if (hasConflictError(responses) && isSingleChapsPayment(responses) && hasMissedDeadlineError(responses)) {
				return state;
			}
			return { ...state, name: pages.ChapsSubmitted };
		}
		case SUBMIT_CHAPS_BATCH_SUCCESS: {
			const responses = getApiResponses(action);
			if (hasConflictError(responses) && hasMissedDeadlineError(responses)) {
				return state;
			}
			return { ...state, name: pages.ChapsSubmitted };
		}
		case SUBMIT_BATCH_CHAPS_REVIEW_SUCCESS: {
			const { hasFailure, responses } = isMultiPartFailure(action);
			if (hasFailure) return { ...state, hasError: true };
			const maxLimitExceeded = hasConflictError(responses);
			if (maxLimitExceeded) return state;
			const { backPage = [], name } = state;
			if (name === pages.ImportedChapsPaymentsPage) {
				return {
					...state,
					name: pages.ChapsReview,
					backPage: [...backPage, name],
				};
			}
			return { ...state, name: pages.ChapsReview };
		}
		case SUBMIT_BATCH_REVIEW_SUCCESS: {
			const { hasFailure, responses } = isMultiPartFailure(action);
			if (hasFailure) return { ...state, hasError: true };
			const maxLimitExceeded = hasConflictError(responses);
			if (maxLimitExceeded) return state;
			const { backPage = [], name } = state;
			if (name === pages.ImportedFasterPaymentsPage) {
				return {
					...state,
					name: pages.FasterPaymentsReview,
					backPage: [...backPage, name],
				};
			}
			return { ...state, name: 'Review' };
		}
		case SUBMIT_BATCH_SUCCESS:
			return { ...state, name: 'Confirmed' };
		case SUBMIT_CHAPS_BATCH_FAILURE: {
			if (isDailyLimitOrCustomerDeviceError(action)) {
				return { ...state, name: pages.ChapsSubmitted };
			}

			if (isReadTimeOutStatus(action)) {
				return { ...state, hasReadTimeOutError: true };
			}

			return { ...state, hasError: true };
		}
		case SUBMIT_BATCH_FAILURE: {
			if (isDailyLimitOrCustomerDeviceError(action)) {
				return { ...state, name: 'Confirmed' };
			}

			if (isReadTimeOutStatus(action)) {
				return { ...state, hasReadTimeOutError: true };
			}

			return { ...state, hasError: true };
		}
		case SUBMIT_CONFIRMED_PAYMENT_FAILURE:
		case SUBMIT_CHAPS_CONFIRMED_PAYMENT_FAILURE:
		case SUBMIT_IFT_PAYMENT_CONFIRMED_FAILURE: {
			if (isReadTimeOutStatus(action)) {
				return { ...state, hasReadTimeOutError: true };
			}
			return { ...state, hasError: true };
		}
		case STORE_BATCH_BUSINESS_ERROR:
			return { ...state, name: 'Confirmed' };
		case SUBMIT_REPEATING_PAYMENT_REVIEW_SUCCESS:
			return { ...state, name: 'Review' };
		case SUBMIT_CREATE_TEMPLATE_FAILURE:
			if (isConflictStatus(action)) return state;
			return { ...state, hasError: true };
		case SUBMIT_REPEATING_PAYMENT_REVIEW_FAILURE:
			if (
				isDailyLimitErrorResponse(action) ||
				isMaxTransactionLimitErrorResponse(action) ||
				isRepeatingPaymentLimitErrorResponse(action)
			) {
				return state;
			}
			return { ...state, hasError: true };
		case SUBMIT_CONFIRMED_REPEATING_PAYMENT_SUCCESS:
			return { ...state, name: 'Confirmed' };
		case SUBMIT_CONFIRMED_REPEATING_PAYMENT_FAILURE:
			if (isUnauthorisedStatus(action) || isConflictStatus(action)) {
				return { ...state, name: 'Confirmed' };
			}
			return { ...state, hasError: true };

		case INIT_PAYMENTS_FOR_TEMPLATE:
			return {
				...state,
				name: 'PaymentsCreateNewTemplate',
			};
		case GO_TO_EDIT_FASTERPAYMENT_TEMPLATE:
			return {
				...state,
				name: 'PaymentsEditTemplate',
			};
		case GO_TO_MANAGE_PAYEE_PAGE:
			return {
				name: 'ManageYourPayee',
			};
		case GO_TO_VIEW_PAYEE_PAGE:
			return {
				...state,
				name: 'ViewPayeePage',
			};
		case GO_TO_IMPORT_PAYEES_PAGE:
			return {
				...state,
				name: 'ImportPayeesPage',
			};
		case GO_TO_PAYMENTS_PAGE: {
			return {
				...state,
				name: 'BacsCreditPayments',
			};
		}
		case GO_TO_DEBIT_PAYMENTS_PAGE: {
			return {
				...state,
				name: 'BacsDebitPayments',
			};
		}
		case GO_TO_DEBIT_LANDING_PAGE: {
			return {
				...state,
				name: 'BacsDebitLanding',
			};
		}
		case GO_TO_CREDIT_LANDING_PAGE: {
			return {
				...state,
				name: 'BacsCreditLanding',
			};
		}
		case SUBMIT_BACS_PAYMENT_REVIEW_SUCCESS: {
			const { backPage = [], name } = state;
			if (name === pages.BacsImportedCreditPaymentPage) {
				return {
					...state,
					name: pages.BacsCreditReview,
					backPage: [...backPage, name],
				};
			}
			return {
				...state,
				name: 'BacsCreditReview',
			};
		}
		case SUBMIT_CONFIRMED_BACS_PAYMENTS_SUCCESS:
			return {
				...state,
				name: 'BacsCreditSubmitted',
			};
		case SUBMIT_BACS_PAYMENT_REVIEW_FAILURE:
			if (isConflictStatus(action)) return state;
			return {
				...state,
				hasError: true,
			};
		case SUBMIT_CONFIRMED_BACS_PAYMENTS_FAILURE: {
			if (isConflictStatus(action)) return state;
			if (isUnauthorisedStatus(action) || isCustomerDeviceErrorResponse(action)) {
				return {
					...state,
					name: 'BacsCreditSubmitted',
				};
			}
			return {
				...state,
				hasError: true,
			};
		}
		case SUBMIT_BACSDEBIT_PAYMENT_REVIEW_SUCCESS: {
			const { backPage = [], name } = state;
			if (name === pages.BacsImportedDebitPaymentPage) {
				return {
					...state,
					name: pages.BacsDebitReview,
					backPage: [...backPage, name],
				};
			}
			return {
				...state,
				name: 'BacsDebitReview',
			};
		}
		case SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_SUCCESS:
			return {
				...state,
				name: 'BacsDebitSubmitted',
			};
		case SUBMIT_BACSDEBIT_PAYMENT_REVIEW_FAILURE:
			if (isConflictStatus(action)) return state;
			return {
				...state,
				hasError: true,
			};
		case SUBMIT_IFT_EDIT_PAYMENT_FAILURE: {
			if (isUnauthorisedStatus(action)) {
				return state;
			}
			return {
				...state,
				hasError: true,
			};
		}

		case SUBMIT_CONFIRMED_BACSDEBIT_PAYMENTS_FAILURE: {
			if (isConflictStatus(action)) return state;
			if (isUnauthorisedStatus(action) || isCustomerDeviceErrorResponse(action)) {
				return {
					...state,
					name: 'BacsDebitSubmitted',
				};
			}

			return {
				...state,
				hasError: true,
			};
		}
		case GO_TO_BACS_TEMPLATE:
		case CREATE_NEW_BACS_TEMPLATE:
			if (action.bacsType === TYPE_BACS_CREDIT) {
				return {
					...state,
					name: 'BacsCreditPaymentsTemplate',
				};
			}

			return {
				...state,
				name: 'BacsDebitPaymentsTemplate',
			};
		case RESET_MANDATE_LIST:
		case GET_MANDATES_MULTIPART_SUCCESS:
			return {
				...state,
				hasError: false,
			};
		case VIEW_MANDATE:
			return {
				...state,
				name: 'ViewPayment',
			};
		case EDIT_MANDATE:
			return {
				...state,
				name: 'EditPayment',
			};
		case VIEW_MANDATE_BACK:
			return {
				...state,
				name: 'ManagePaymentLandingPage',
			};
		case SET_SHARED_DATA:
			return {
				...state,
				sharedData: action.data,
			};
		case SUBMIT_ADD_INTERNATIONAL_PAYEE_FAILURE:
		case SUBMIT_ADD_PAYEE_FAILURE: {
			if (isBadRequestStatus(action) || isConflictStatus(action)) {
				return state;
			}
			return { ...state, hasError: true };
		}
		case SUBMIT_CHAPS_EDIT_PAYMENT_FAILURE: {
			if (isUnauthorisedStatus(action) || isConflictStatus(action)) return state;
			return { ...state, hasError: true };
		}
		case BENEFICIARY_CREATE_SUCCESS: {
			const hasBenFailed = getApiResponses(action).some((response) => hasBeneficiaryFailed(response));
			if (hasBenFailed) {
				return { ...state, hasError: true };
			}
			return state;
		}
		case GET_ACCOUNT_DETAILS_BY_ID_FAILURE: {
			if (isForbidden(action)) return state;
			return { ...state, hasError: true };
		}
		case RESET_APP: {
			return {
				...state,
				hasReadTimeOutError: false,
			};
		}
		default:
			return state;
	}
};

export default page;
